<template>
    <div>

        <el-row style="margin-bottom:10px;">
            <el-col :span="18" class='flex'>
                <el-select v-if="theUserProject == 0" v-model="theProjectId" @change="theProjectAllChange" size="small"
                    clearable placeholder="请选择项目">
                    <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                        :label="item.projectName" :value="item.projectId">
                    </el-option>
                </el-select>
                <el-input v-model="getYcAiTrainBaseList_data.yatbTitle" placeholder="请输入标题" clearable size='small'
                    style="max-width:200px;" />
                <!-- <el-select v-model='getYcAiTrainBaseList_data.mtmId' clearable placeholder="请输入分类" size='small'
                    style="max-width:200px;">
                    <el-option v-for="item in getMicrolectureTypeMainList_data || []" :key="item.mtmId"
                        :label="item.mtmName" :value="item.mtmId"></el-option>
                </el-select> -->
                <el-button @click="getData" type="primary" icon='el-icon-search' size='small'
                    style='margin-left:10px;'>搜索
                </el-button>
            </el-col>
            <el-col :span="6">
                <el-button v-if="addYcAiTrainBase" @click=" $form('addYcAiTrainBase')" size='small' type="primary"
                    style="float:right" icon='el-icon-circle-plus'>添加智能演练场景分类
                </el-button>
            </el-col>
        </el-row>

        <mytable ref="mytable" :tableColums='tableColums_getYcAiTrainBaseList' api='getYcAiTrainBaseList::yatbId'
            xupdateapi='updateYcAiTrainBase' :height="H - 165">
            <icol slot='yatbCover' :showtooltip='false' img='yatbCover' />
        </mytable>
        <myform :viewobj='{
            updateYcAiTrainBaseCopyToOtherProject: ["复制智能演练到其他项目", "el-icon-edit-outline"],
            $succeed$: getYcAiTrainBaseList
        }' @closed="$form('updateYcAiTrainBaseCopyToOtherProject', 'reset'), window.sleep(50, v => Myformdata)
            ">
            <template v-slot:projectId="{ Myformdata }">
                <el-select v-model="Myformdata.projectId" clearable placeholder="请选择项目">
                    <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId"
                        :label="item.projectName" :value="item.projectId">
                    </el-option>
                </el-select>
            </template>
            <hide slot='yatbId' />
        </myform>
        <myform :viewobj='{
            addYcAiTrainBase: ["新增智能演练场景分类", "el-icon-circle-plus"],
            updateYcAiTrainBase: ["修改智能演练场景分类", "el-icon-edit-outline"],
            $succeed$: getYcAiTrainBaseList
        }' @closed="$form('updateYcAiTrainBase', 'reset'), window.sleep(50, v => Myformdata && (Myformdata.aaIcon = ''))
            " @confirm='myform'>
            <template v-slot:yatcId="{ Myformdata }">
                <el-cascader ref='cascader' v-model="Myformdata.yatcId" clearable filterable size='small'
                    placeholder='请选择分类' :show-all-levels='false'
                    :options="getYcAiTrainClassList_data ? getYcAiTrainClassList_data.data : []"
                    :props="{ expandTrigger: 'hover', checkStrictly: true, emitPath: false, label: 'yatcName', value: 'yatcId', children: 'children' }"
                    @change="$refs.cascader.dropDownVisible = false">
                    <template slot-scope="{ data }">
                        <span onclick="this.parentNode.previousElementSibling.click()">{{ data.yatcName }}</span>
                    </template>
                </el-cascader>
            </template>
            <template v-slot:yaaId="{ Myformdata }">
                <el-select v-model='Myformdata.yaaId' clearable placeholder="请选择智能体" style="max-width:200px;">
                    <el-option v-for="(item, index) in getYcAiAppList_data.data || []" :key="index"
                        :label="item.aaTitle" :value="item.yaaId"></el-option>
                </el-select>
            </template>
            <template v-slot:yatbQuestionsType="{ Myformdata }">
                <el-select v-model='Myformdata.yatbQuestionsType' clearable placeholder="请选择提问方式"
                    style="max-width:200px;">
                    <el-option label="程序自动第一问" :value="1"></el-option>
                    <el-option label="只给示例不发问" :value="2"></el-option>
                </el-select>
            </template>
            <template v-slot:yatbBackgroundDes="{ Myformdata }">
                <el-input type="textarea" v-model="Myformdata.yatbBackgroundDes" style="width: 100%;"></el-input>
            </template>
            <template v-slot:yatbQuestionExample="{ Myformdata }">
                <el-input type="textarea" v-model="Myformdata.yatbQuestionExample" style="width: 100%;"></el-input>
            </template>
            <template v-slot:yatbCover='{ Myformdata }'>
                <myupload v-event.fileUpload='`
                      return (Myformdata.yatbCover+"").startsWith("http") 
                        || ( (C = (await C.MyUpload()).file) ? Myformdata.yatbCover = C : false )
                    `' @change='Myformdata.yatbCover = ($file$ = arguments[0]).url'
                    @remove='window.sleep(150, v => Myformdata.yatbCover = "")' type='image' :limit='1'
                    :params='{ file: "$file$" }' :filelist="Myformdata.yatbCover && Myformdata.yatbCover != ' '
                        ? ({ name: Myformdata.yatbCover, url: Myformdata.yatbCover })
                        : false"
                    :style="{ height: Myformdata.yatbCover && $form('updateMicrolecture', 'ifshow') ? '250px' : '' }">
                </myupload>
            </template>
            <hide slot='yatbId' />
        </myform>
    </div>
</template>

<script>
export default {
    data() {
        return {
            mainType: [],
            yatbId: null,
            theyatbId: "",
            getMicrolectureTypeMainList_data: [],
            tableColums_getYcAiTrainBaseList: {
                $selection: false,
                yatbTitle: '标题',
                yatcName: '分类',
                aaTitle: '智能体',
                yatbCover: '封面',
                yatbDes: '背景',
                yatbBaseQuestions: '开场场景',
                yatbScorePass: '通过分数',
                yatbOrder: '排序',
                yatbStatus: ['状态', , '@v-if: 1:待发布#danger, 2:已发布#success,3:下架#danger+'],
                createtime: '创建时间',

                $operation: [
                    '操作', 300,
                    this.updateYcAiTrainBaseCopyToOtherProject && `@text: 复制到其他项目#primary
                    @click: $form("updateYcAiTrainBaseCopyToOtherProject",$row)
            `,
                    this.updateYcAiTrainBase && `@text: 编辑#warn
             @click: $form("updateYcAiTrainBase",$row)
            `,
                    this.deleteYcAiTrainBase && `@text: 删除#danger
             @click: _confirm('确定要删除吗?')
                     .trigger('deleteYcAiTrainBase',{yatbId:$row.yatbId})
                     .trigger('getYcAiTrainBaseList')
            `,
                    this.updateYcAiTrainBaseUp && `@text: 上架#success
           @click: _confirm('确定要上架该场景吗?')
                   .trigger('updateYcAiTrainBaseUp',{yatbId:$row.yatbId})
                   .trigger('getMicrolectureList')
          `,
                    this.updateYcAiTrainBaseDown && `@text: 下架#danger
           @click: _confirm('确定要下架该场景吗?')
                   .trigger('updateYcAiTrainBaseDown',{yatbId:$row.yatbId})
                   .trigger('getMicrolectureList')
          `,
                ],

            },

        };
    },

    watch: {

    },

    methods: {
        hasChildrenChange(value) {
            if (value.children && value.children.length > 0) {
                return (value.hasChildren = true);
            } else {
                return (value.hasChildren = false);
            }
        },
        cellMouseEnter(row, column, cell, event) {
            this.rowShow = row.projectId;
            this.columnShow = column.property;
        },
        cellMouseLeave(row, column, cell, event) {
            this.rowShow = "";
            this.columnShow = "";
        },
        expand(row, expanded) {
            if (row.dtLevel == 1 || row.hasChildren2 === false) return;
            const treeData = this.$refs.mytable.Table.store.states.treeData,
                children = (treeData[row._parent] || 0).children || "";
            if (children.length < 2) return;
            // console.error(row, expanded, row._parent, children, row.hasChildren);
            for (let id of children) {
                if (id !== row.projectId)
                    treeData[id] && (treeData[id].expanded = false);
            }
            return;
        },
        async myform(submit, Myformdata) {
            const res = await this.$trigger("fileUpload").trigger(res => res && this.sub(submit))
        },
        async sub(submit) {
            this.$nextTick(() => {

            })
            submit();
        },
        theProjectAllChange(e) {
            this.theProjectId = e;
            this.getData()
        },
        getData() {
            this.getYcAiTrainBaseList({
                ...this.getYcAiTrainBaseList_data,
                projectId: this.theProjectId
            })
        }
    },

    async created() {
        //   this.getMicrolectureTypeMainLists().result((res) => {
        //     if (res.data.data) {
        //       console.log(res.data.data);
        //       this.getMicrolectureTypeMainList_data = res.data.data
        //     }
        //   }) 
        this.theUserProject = A.local("$projectId");
        if (this.theUserProject == 0) {
            this.getProjectList({
                pageSize: 0
            });
        } else {
            this.theProjectId = this.theUserProject;
        }
        this.getYcAiTrainClassList({ pageSize: 0 });
        this.getYcAiAppList({ pageSize: 0 });
        this.getYcAiTrainBaseList();
    }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/views/AiAgent/AiScenc.vue